import { useEffect, useRef, useState } from 'react'
import { Button } from 'reactstrap'
import { formatCountdown, impersonationInfo, remainingSeconds } from '../../../utility/impersonation'

const bannerStyle = {
  position: 'sticky',
  top: 0,
  zIndex: 2000,
  background: '#ff9f43',
  color: '#fff',
  padding: '6px 16px',
  textAlign: 'center',
  fontWeight: 600
}

const useCountdown = (exp, now) => {
  const [seconds, setSeconds] = useState(() => (exp ? remainingSeconds(exp, now()) : 0))
  useEffect(() => {
    if (!exp) return undefined
    setSeconds(remainingSeconds(exp, now()))
    const timer = setInterval(() => setSeconds(remainingSeconds(exp, now())), 1000)
    return () => clearInterval(timer)
  }, [exp])
  return seconds
}

// Global "Viewing as" banner (spec B4). Renders only for impersonation tokens.
const ImpersonationBanner = ({ claims, onExit, now = () => Date.now() }) => {
  const info = impersonationInfo(claims)
  const seconds = useCountdown(info?.exp, now)
  const exited = useRef(false)
  const exit = () => {
    if (exited.current) return
    exited.current = true
    onExit()
  }

  useEffect(() => {
    if (info && info.exp && seconds === 0) exit()
  }, [seconds, info?.exp])

  if (!info) return null
  return (
    <div style={bannerStyle} role='status' data-testid='impersonation-banner'>
      Viewing as {info.name} ({info.email}) — read-only — ends in {formatCountdown(seconds)} ·{' '}
      <Button size='sm' color='light' data-action='exit-impersonation' onClick={exit}>Exit</Button>
    </div>
  )
}

export default ImpersonationBanner
